<template>
  <div class="bottom-bg ">
    <div class="bottom w1600 auto">
      <div class="df align_center">
        <div class="bottom-nav df  pt50 mra">
          <dl class="bottom-nav-item fw pl15">
            <dt class="op50">印象富林</dt>
            <dd class=" lh20">
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/yinxiang/index">富林印迹</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/yinxiang/spot">富林景点</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <a href="https://pano.gflpark.com/pano/?module=pano" target="_blank">全景导览</a>
              </div>
            </dd>
          </dl>
          <dl class="bottom-nav-item fw pl15">
            <dt class="op50">玩转富林</dt>
            <dd class=" lh20">
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/wanzhuan/index">入园指南</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/wanzhuan/jiaotong">交通指南</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/wanzhuan/gonglue">游记攻略</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/wanzhuan/yanyi">精彩演绎</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/wanzhuan/jinianpin">纪念品展示</router-link>
              </div>
            </dd>
          </dl>
          <dl class="bottom-nav-item fw pl15">
            <dt class="op50">景区资讯</dt>
            <dd class=" lh20">
              <!-- <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/zixun">富林活动</router-link>
              </div> -->
              <!-- <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/zixun/zixun-announcement">公告信息</router-link>
              </div> -->
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/zixun/zixun-company">景区资讯</router-link>
              </div>
            </dd>
          </dl>
          <dl class="bottom-nav-item fw pl15">
            <dt class="op50">预订服务</dt>
            <dd class=" lh20">
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/yuding/index">在线购票</router-link>
              </div>
              <div v-if="dynamicLinkData && dynamicLinkData.Items && dynamicLinkData.Items.length > 0">
                <div class="bottom-nav-box mt5 f15 fa_wh" v-for="(item, index) in dynamicLinkData.Items" :key="index">
                  <a :href="item.ThirdLink.Path" target="_blank">{{ item.Name }}</a>
                </div>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/yuding/food">美食餐饮</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/yuding/hotel">客房住宿</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/yuding/leisure">休闲娱乐</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/yuding/vip">贵宾服务</router-link>
              </div>
            </dd>
          </dl>
          <dl class="bottom-nav-item fw pl15">
            <dt class="op50">联系我们</dt>
            <dd class=" lh20">
              <!-- <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/">游客意见</router-link>
              </div> -->
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/lianxi/index">联系我们</router-link>
              </div>
              <div class="bottom-nav-box mt5 f15 fa_wh">
                <router-link to="/pages/lianxi/lianxi-team">团队、企业合作</router-link>
              </div>
            </dd>
          </dl>
        </div>
        <div class="df align_center justify_end">
          <div class="df flex_column align_center justify_center mr20">
            <div v-if="data && data.Items && data.Items[0].Photo">
              <img :src="data.Items[0].Photo" width="130" height="130" class="w130 db" alt="">
            </div>
            <div class="mt5 fw">广富林购票小程序</div>
          </div>
          <div class="df flex_column align_center justify_center pl5">
            <div v-if="data && data.Items && data.Items.length > 1 && data.Items[1].Photo">
              <img :src="data.Items[1].Photo" width="130" height="130" class="w130 db" alt="">
            </div>
            <div class="mt5 fw">微信公众号</div>
          </div>
        </div>
      </div>
      <div class="df align_center op50 mt50 pt10 justify_center fw" v-if="data && data.Items && data.Items.length > 2" v-html="data.Items[2].ContentText">
      </div>
      <div class="df align_center op50 mt50 pt10 justify_center fw" v-else>
        <div class="mr20">
          Copyright © 2025 上海松江大学城建设发展有限公司
        </div>
        <div class="mr20"> <img src="../assets/images/beian-icon.png" class="box20" alt=""><a style="color: white;" href="http://www.beian.miit.gov.cn/" target="_blank">沪ICP备18016539号</a></div>
        <div><a style="color: white;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702006113" target="_blank">沪公安网备 31011702006113号</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      code: 'app-bottom',
      data: null,
      dynamicLinkCode: 'app-ydfw-dynamic-link',
      dynamicLinkData: null,
    }
  },
  mounted() {
    this.loadData();
    this.loadDynamicLink();
  },
  methods:{
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.data = data;
        }
      })
    },
    loadDynamicLink(){
      promotionService.detail(this.dynamicLinkCode).then(res => {
        if(res.Code == 200) {
          this.dynamicLinkData = res.Data;
        }
      })
    },
  },
}
</script>

<style scoped>

 

</style>



// WEBPACK FOOTER //
// src/components/bottom.vue